const FILE_NAME = 'render-input.png'
const MIME_TYPE = 'image/png'

// The viewer exposes no screenshot API, and its WebGL fallback does not preserve the
// drawing buffer, so a canvas read between frames can come back blank. Rendering a frame
// right before toBlob, in the same task, guarantees the bitmap holds the current pose.
// renderer/scene/camera are private viewer fields: if an upgrade renames them the frame
// is skipped and the read falls back to whatever the canvas holds.
const renderCurrentFrame = (viewer) => {
  const { renderer, scene, camera } = viewer
  if (typeof renderer?.render === 'function' && scene && camera?.instance) {
    renderer.render(scene, camera.instance)
  }
}

/**
 * Captures what the viewer currently shows as a PNG file.
 *
 * @param {Object|null} viewer - The @cgtrader/cgt-viewer instance (staticViewer.instance)
 * @returns {Promise<File|null>} Null when there is no viewer or the canvas cannot be read
 */
export default function captureViewerImage(viewer) {
  const canvas = viewer?.isDisposed === false ? viewer.getCanvasElement() : null
  if (!canvas) {
    return Promise.resolve(null)
  }

  renderCurrentFrame(viewer)

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob ? new File([blob], FILE_NAME, { type: MIME_TYPE }) : null)
    }, MIME_TYPE)
  })
}
